import { UserService } from "./UserService";
import { PasswordRecoveryDTO, PasswordResetDTO } from "@/@types/dtos/password-reset.types";
import { Endpoints, Http, HttpService } from "@/infra/api";
import { useMainStore } from "@/infra/store";
import { ApiResponse, LoginDTO, LoginResponse } from "@/@types";

export interface Auth {
  login: (params: LoginDTO) => Promise<void>;
  passwordRecovery: (params: PasswordRecoveryDTO) => Promise<ApiResponse<any>>;
  passwordReset: (params: PasswordResetDTO) => Promise<ApiResponse<any>>;
  updateUserLocalSession: () => Promise<boolean>;
}

export const AuthService = (http: Http = HttpService()): Auth => {
  return {
    async login(params) {
      const store = useMainStore();

      const { data: loginData } = await http.post<LoginDTO, LoginResponse>(
        Endpoints.login,
        params
      );

      await store.saveToken(loginData.access_token);
      const { data: userData } = await UserService(http).getUser(
        loginData.user.id
      );
      await store.saveSession(userData);
    },
    async passwordRecovery(params: PasswordRecoveryDTO) {
      return http.post(Endpoints.password_recovery, params);
    },
    async passwordReset(params: PasswordResetDTO) {
      return http.post(Endpoints.password_reset, params);
    },
    async updateUserLocalSession() {
      const store = useMainStore();
      if (!store.session) return false
      const { data: userData } = await UserService(http).getUser(
        store.session.id
      );
      await store.saveSession(userData);
      return true
    },
  };
};
